// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import $ from 'jquery'
// let jQuery = $
// window.jQuery = window.$ = jQuery

import './jquery'
import $ from 'jquery'

// Bugfix
// https://stackoverflow.com/questions/60357083/does-not-use-passive-listeners-to-improve-scrolling-performance-lighthouse-repo
// // Passive event listeners
$.event.special.wheel = {
  setup: function(_, ns, handle) {
    this.addEventListener('wheel', handle, {
      passive: !ns.includes('noPreventDefault'),
    })
  },
}
$.event.special.touchstart = {
  setup: function(_, ns, handle) {
    this.addEventListener('touchstart', handle, {
      passive: !ns.includes('noPreventDefault'),
    })
  },
}
$.event.special.touchmove = {
  setup: function(_, ns, handle) {
    this.addEventListener('touchmove', handle, {
      passive: !ns.includes('noPreventDefault'),
    })
  },
}

import _ from 'lodash'
// import $ from 'jquery'
import Chart from 'chart.js'
import 'bootstrap'
import 'chartjs-plugin-datalabels'

import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import BootstrapVue from 'bootstrap-vue'
import fullscreen from 'vue-fullscreen'

import App from './App'
import i18n from './i18n'
import router from './router'
import store from './store'
import { subscription_object_collection } from './components/mixin'
import { socket } from '@/aiplatform_socketio'

import { brick_info_from_name } from '@/components/bricks_infos_core.js'
import '@/components/bricks_infos.js'
// *****************************************************************************

subscription_object_collection.set_store(store)

Chart.defaults.global.defaultFontFamily = "'Bitter', serif"
Chart.defaults.global.plugins.datalabels.display = false

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(fullscreen)

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: socket,
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
    },
  })
)

// *****************************************************************************

// This was created because bootstrap vue tooltips crashes Chrome
// The mechanism here relies only on bootstrap's implementation
// to the opposite of bootstrap vue which creates its own tooltip class
// These tooltips are properly deleted, updated when their content
// changes and only one such tooltip can be displayed on screen
// at the same time...
// https://github.com/vuejs/vue/issues/6385

const CTooltipDirective = (() => {
  const state = new WeakMap()
  let cur_el
  return {
    bind(el, binding, vnode) {
      state.set(el, binding.value)
      $(el)
        .tooltip({
          title: () => state.get(el),
          container: 'body',
          delay: { show: 1000, hide: 0 },
        })
        .on('show.bs.tooltip', function() {
          if (el === cur_el) {
            return
          }
          if (!_.isUndefined(cur_el)) {
            $(cur_el).tooltip('hide')
          }
          cur_el = el
        })
        .on('hide.bs.tooltip', function() {
          if (el === cur_el) {
            cur_el = undefined
          }
        })
    },
    update(el, binding, vnode) {
      state.set(el, binding.value)
    },
    unbind(el, binding, vnode) {
      if (cur_el === el) {
        cur_el = undefined
      }
      $(el).tooltip('dispose')
      state.delete(el)
    },
  }
})()

Vue.directive('c-tooltip', CTooltipDirective)

// *****************************************************************************

new Vue({
  ...App,
  router,
  store,
  i18n,
}).$mount('#app')
